import type { LinkProps } from 'react-router-dom';

import { forwardRef } from 'react';
import { Link } from 'react-router-dom';

// ----------------------------------------------------------------------

/**
 * Adapter that preserves the previous Next.js `<RouterLink href="...">` API on
 * top of React Router's `<Link to="...">`, so existing call sites (incl. MUI
 * `component={RouterLink} href={...}`) keep working.
 */
export type RouterLinkProps = Omit<LinkProps, 'to'> & { href: string };

export const RouterLink = forwardRef<HTMLAnchorElement, RouterLinkProps>(
  ({ href, ...other }, ref) => <Link ref={ref} to={href} {...other} />
);

RouterLink.displayName = 'RouterLink';
